import React, { ReactNode, useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { Routes } from 'routes';
import { createStyles } from 'utils/createStyle';
import AddCardModal from './AddCardModal';

const styles = createStyles({
    main: [
        'md:grid mt-10 sm:mt-20 px-4',
        {
            gridTemplateColumns: 'auto max-content minmax(350px, 780px) auto',
        },
    ],
    menuSm: ['sm:hidden mb-2', { width: '200px' }],
});

export const MainLayout = ({
    section,
    children,
}: {
    section: 'archived' | 'active' | 'detail';
    children?: ReactNode;
}) => {
    const archivedCardsRoute = `${Routes.WalletMyCards}?section=archived`;
    const myCardsRoute = `${Routes.WalletMyCards}?section=my-cards`;

    const currentLinkStyles = 'no-underline text-brand-dark';

    const isMyCards = section === 'active';
    const isArchived = section === 'archived';

    const [showModal, setShowModal] = useState(false);

    return (
        <div className={styles.main}>
            <div></div>
            <div>
                <div>
                    <div>
                        <AddCardModal isOpen={showModal} closeModal={() => setShowModal(false)} />
                        <h1 className="font-light text-brand-dark text-3xl sm:text-5xl mb-6 col-span-2">
                            Wallet
                        </h1>
                    </div>
                    <div className={styles.menuSm}>
                        <nav className="flex flex-row gap-8">
                            <Link
                                className={classNames(
                                    'text-xs font-semibold',
                                    isMyCards && currentLinkStyles
                                )}
                                to={myCardsRoute}
                            >
                                My Cards
                            </Link>
                            <Link
                                className={classNames(
                                    'text-xs font-semibold',
                                    isArchived && currentLinkStyles
                                )}
                                to={archivedCardsRoute}
                            >
                                Archive
                            </Link>
                        </nav>
                    </div>
                    <div className="sm:hidden w-full border-t border-grey-5"></div>
                </div>
                <div className="hidden md:block">
                    <nav className="flex flex-col gap-4">
                        <Link
                            className={classNames(
                                'text-xs font-semibold',
                                isMyCards && currentLinkStyles
                            )}
                            to={myCardsRoute}
                        >
                            My Cards
                        </Link>
                        <Link
                            className={classNames(
                                'text-xs font-semibold',
                                isArchived && currentLinkStyles
                            )}
                            to={archivedCardsRoute}
                        >
                            Archive
                        </Link>
                    </nav>
                </div>
            </div>
            <div>
                <div className="w-full items-center mr-auto flex">
                    <button
                        className={classNames(
                            'ml-auto mt-2 bg-brand rounded-full text-white py-2 px-7 w-max font-semibold -mt-32 md:mt-0',
                            !isMyCards ? 'hidden' : 'visible'
                        )}
                        disabled={!isMyCards}
                        onClick={() => setShowModal(true)}
                    >
                        Add Card
                    </button>
                </div>
                <div className="max-w-3xl mt-12 w-full lg:ml-6">{children}</div>
            </div>
            <div></div>
        </div>
    );
};
